import {
  REPROCESSING_INVOICE_CHANNEL,
  REPROCESSING_INVOICE_STATUS,
} from '~/data/invoice-reprocessing';

import { i18n } from '~/utils';

import {
  REPROCESSING_INVOICE_CHANNEL_LABELS,
  REPROCESSING_INVOICE_STATUS_LABELS,
} from '../../constants';

/**
 * Definition of filter names that can be used to filter the invoice reprocessing list.
 */
export const FILTER_NAMES = Object.entries({
  channel: i18n.t(($) => $.list.fields.channel.filterName, {
    ns: 'invoiceReprocessing',
  }),
  comment: i18n.t(($) => $.list.fields.comment.filterName, {
    ns: 'invoiceReprocessing',
  }),
  createdOn: i18n.t(($) => $.list.fields.createdOn.filterName, {
    ns: 'invoiceReprocessing',
  }),
  dryRun: i18n.t(($) => $.list.fields.dryRun.filterName, {
    ns: 'invoiceReprocessing',
  }),
  needsAiParsing: i18n.t(($) => $.list.fields.needsAiParsing.filterName, {
    ns: 'invoiceReprocessing',
  }),
  status: i18n.t(($) => $.list.fields.status.filterName, {
    ns: 'invoiceReprocessing',
  }),
  statusDetails: i18n.t(($) => $.list.fields.statusDetails.filterName, {
    ns: 'invoiceReprocessing',
  }),
}).map(([value, label]) => ({
  value,
  label,
}));

/**
 * Filters that can be inserted multiple times.
 */
export const FILTERS_WITH_MULTIPLE_VALUES = ['channel', 'status'];

/**
 * Definition of values that are suggested when adding a filter with a given name.
 */
export const FILTER_VALUES = {
  channel: REPROCESSING_INVOICE_CHANNEL.map((channel) => ({
    value: channel,
    label: REPROCESSING_INVOICE_CHANNEL_LABELS[channel],
  })),
  dryRun: [
    {
      value: 'true',
      label: i18n.t(($) => $.yes, { ns: 'common' }),
    },
    {
      value: 'false',
      label: i18n.t(($) => $.no, { ns: 'common' }),
    },
  ],
  needsAiParsing: [
    {
      value: 'true',
      label: i18n.t(($) => $.yes, { ns: 'common' }),
    },
    {
      value: 'false',
      label: i18n.t(($) => $.no, { ns: 'common' }),
    },
  ],
  status: REPROCESSING_INVOICE_STATUS.map((status) => ({
    value: status,
    label: REPROCESSING_INVOICE_STATUS_LABELS[status],
  })),
};
